import React from "react";
import { PageHero } from "@/components/site/ui";
import { Reveal } from "@/components/brand";
import { SECTION_IMG, SIGNATURE } from "@/constants/media";

export default function About() {
  return (
    <div>
      <PageHero eyebrow="Our Story" title="About The D" image={SECTION_IMG.interior} />
      <div className="max-w-3xl mx-auto px-6 py-20 space-y-8">
        <Reveal><p className="font-serif text-2xl sm:text-3xl leading-relaxed text-foreground/90">
          The D began as a simple idea: a private place where the people who matter most could gather, unwind, and feel genuinely cared for.
        </p></Reveal>
        <Reveal delay={0.1}><p className="text-muted-foreground leading-relaxed">
          It is not a hotel and never will be. It is a home — reimagined as an intimate resort and social house. Electric-blue water,
          warm light through ivory curtains, tropical greenery, and a soundtrack that shifts from Miami Nights to Quiet Morning. Every
          detail is chosen to make you feel like the only guests in the world.
        </p></Reveal>
        <Reveal delay={0.15}><p className="text-muted-foreground leading-relaxed">
          We keep it private on purpose. Access is by invitation, referral, or a personal request reviewed by your host. That is what
          lets us make it special — for you, and for everyone who has ever spent a night here.
        </p></Reveal>
        <Reveal delay={0.2}><div className="gold-line my-4" /><p className="font-serif italic text-gold text-2xl text-center">{SIGNATURE}</p></Reveal>
      </div>
    </div>
  );
}
